import TYPES from '@/modules/shared/types';

// Domain
import { GoalEarningsRepository } from '../../domain/repositories/goal-earnings-repository';
import { GoalEarningsEntity } from '../../domain/entities/goal-earnings-entity';
import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';
import HttpConnector from '@/modules/shared/domain/connectors/http';

@Injectable()
export default class GoalEarningsHttpRepository implements GoalEarningsRepository {
  @Inject(TYPES.HTTP_CONNECTOR)
  private readonly http_connector!: HttpConnector;

  private readonly endpoint = `${process.env.VUE_APP_API_URL}/api/v1/app/flagship/investor-goal/{investor_goal_id}/earnings/`;

  get(investor_goal_id: string): Promise<GoalEarningsEntity> {
    return new Promise((resolve, reject) => {
      this.http_connector.execute(this.endpoint.replace('{investor_goal_id}', investor_goal_id))
        .then((response) => {
          response.json()
            .then(({ success, data, error }) => {
              if (success) {
                resolve(data);
              } else {
                reject(new Error(error));
              }
            });
        })
        .catch(reject);
    });
  }
}
